import { gql } from '@apollo/client';
import { SCHEDULE_FRAGMENT } from '../../fragments';

export const GET_SCHEDULE_BY_SEASON_ID = gql`
  ${SCHEDULE_FRAGMENT}
  query GetScheduleBySeasonId($seasonId: Int!, $teamId: Int, $date: date) {
    schedule(
      order_by: { date: asc, time: asc }
      where: {
        seasonId: { _eq: $seasonId }
        date: { _gte: $date }
        home: { _eq: $teamId }
        away: { _eq: $teamId }
      }
    ) {
      ...ScheduleFragment
    }
  }
`;
